"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: gift-card/gift-card.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fgift-card%2Fgift-card.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardStatusToJSON = exports.giftCardStatusFromJSON = exports.GiftCard = exports.GiftCardStatus = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.giftcard.proto';
var GiftCardStatus;
(function (GiftCardStatus) {
    GiftCardStatus["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
    /**
     * PENDING - Pending. Gift card is not ready yet.
     */
    GiftCardStatus["PENDING"] = "PENDING";
    /**
     * READY - Ready. Gift card is ready to be used.
     */
    GiftCardStatus["READY"] = "READY";
    /**
     * FAILED - Failed. Gift card failed to order.
     */
    GiftCardStatus["FAILED"] = "FAILED";
    GiftCardStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GiftCardStatus || (exports.GiftCardStatus = GiftCardStatus = {}));
function createBaseGiftCard() {
    return {
        orderId: '',
        status: GiftCardStatus.INVALID_ORDER_STATUS,
        orderCreatedAtMs: '0',
        productName: '',
        cardImageUrl: '',
        cardValue: amount_1.Amount.fromPartial({}),
        certificateLink: '',
        paymentId: '',
        archivedAtMs: '0',
        failureMessage: '',
    };
}
exports.GiftCard = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
            status: isSet(object.status)
                ? giftCardStatusFromJSON(object.status)
                : GiftCardStatus.INVALID_ORDER_STATUS,
            orderCreatedAtMs: isSet(object.orderCreatedAtMs)
                ? globalThis.String(object.orderCreatedAtMs)
                : '0',
            productName: isSet(object.productName) ? globalThis.String(object.productName) : '',
            cardImageUrl: isSet(object.cardImageUrl) ? globalThis.String(object.cardImageUrl) : '',
            cardValue: isSet(object.cardValue)
                ? amount_1.Amount.fromJSON(object.cardValue)
                : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.certificateLink)) {
            message.certificateLink = globalThis.String(object.certificateLink);
        }
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.archivedAtMs)) {
            message.archivedAtMs = globalThis.String(object.archivedAtMs);
        }
        if (isSet(object.failureMessage)) {
            message.failureMessage = globalThis.String(object.failureMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.status !== GiftCardStatus.INVALID_ORDER_STATUS) {
            obj.status = giftCardStatusToJSON(message.status);
        }
        if (message.orderCreatedAtMs !== '0') {
            obj.orderCreatedAtMs = message.orderCreatedAtMs;
        }
        if (message.productName !== '') {
            obj.productName = message.productName;
        }
        if (message.cardImageUrl !== '') {
            obj.cardImageUrl = message.cardImageUrl;
        }
        if (message.cardValue !== undefined) {
            obj.cardValue = amount_1.Amount.toJSON(message.cardValue);
        }
        if (message.certificateLink !== undefined && message.certificateLink !== '') {
            obj.certificateLink = message.certificateLink;
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.archivedAtMs !== undefined && message.archivedAtMs !== '0') {
            obj.archivedAtMs = message.archivedAtMs;
        }
        if (message.failureMessage !== undefined && message.failureMessage !== '') {
            obj.failureMessage = message.failureMessage;
        }
        return obj;
    },
    create(base) {
        return exports.GiftCard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCard();
        message.orderId = object.orderId ?? '';
        message.status = object.status ?? GiftCardStatus.INVALID_ORDER_STATUS;
        message.orderCreatedAtMs = object.orderCreatedAtMs ?? '0';
        message.productName = object.productName ?? '';
        message.cardImageUrl = object.cardImageUrl ?? '';
        message.cardValue = (object.cardValue !== undefined && object.cardValue !== null)
            ? amount_1.Amount.fromPartial(object.cardValue)
            : amount_1.Amount.fromPartial({});
        message.certificateLink = object.certificateLink ?? '';
        message.paymentId = object.paymentId ?? '';
        message.archivedAtMs = object.archivedAtMs ?? '0';
        message.failureMessage = object.failureMessage ?? '';
        return message;
    },
};
function giftCardStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ORDER_STATUS':
            return GiftCardStatus.INVALID_ORDER_STATUS;
        case 1:
        case 'PENDING':
            return GiftCardStatus.PENDING;
        case 2:
        case 'READY':
            return GiftCardStatus.READY;
        case 3:
        case 'FAILED':
            return GiftCardStatus.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return GiftCardStatus.UNRECOGNIZED;
    }
}
exports.giftCardStatusFromJSON = giftCardStatusFromJSON;
function giftCardStatusToJSON(object) {
    switch (object) {
        case GiftCardStatus.INVALID_ORDER_STATUS:
            return 'INVALID_ORDER_STATUS';
        case GiftCardStatus.PENDING:
            return 'PENDING';
        case GiftCardStatus.READY:
            return 'READY';
        case GiftCardStatus.FAILED:
            return 'FAILED';
        case GiftCardStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.giftCardStatusToJSON = giftCardStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=gift-card.js.map